import { DialogTitle, Grid2 } from "@mui/material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import Export from "./Export";
import FilterFrom from "./FilterFrom";
import FilterTo from "./FilterTo";

const UIText = {
  "es-CL": { header: "Versiones antiguas" },
  "en-US": { header: "Old versions" },
};

const Header = ({allFiles}) => {
  const { auth,settings } = useUIBp();
  const { header } = UIText[settings.locale];

  return (
    <DialogTitle>
      <Grid2 container justifyContent="space-between" alignItems="center">
        {header}
        <Grid2 container size="auto" columnSpacing={1} justifyContent="flex-end">
          <FilterFrom />
          <FilterTo />
      {auth.group === 1 ? <Export {...{ allFiles }} /> : null}
        </Grid2>
      </Grid2>
    </DialogTitle>
  );
};

export default Header;
